module.exports = __webpack_public_path__ + "static/playgroundsmanager-91a035c69e502b6d8a64afdae9e49d1b.png";